import { EventBus } from '@/views/DownPage/EventBus.js'
// import { getDownloadTokenAPI } from '@/utils/apiList/downpage'
export default {
  namespaced: true,
  state: {
    wsDown: null,
    downHeartBeatTimer: null,
    heartBeatMessage: 'hb',
    downSocketNum: null,
    downRetryCount: 0,
  },
  mutations: {
    SET_WS_DOWN(state, value) {
      state.wsDown = value
    },
    SET_HEARTBEAT_TIMER(state, timer) {
      state.downHeartBeatTimer = timer
    },
    SET_SOCKET_NUM(state, num) {
      state.downSocketNum = num
    },
    SET_RETRY_COUNT(state, count) {
      state.downRetryCount = count
    },
  },
  actions: {
    async checkSocketNeed({ dispatch, rootState, commit }, type = 1) {
      // type为2是C页下载，不需要判断是否首次下载
      const userInfo = rootState.userInfo
      // 根据传入的type参数判断不同的条件
      let shouldProceed = false
      if (type == 1) {
        // 列表和下载页：需要同时满足非会员和下载数为0的条件
        // console.log('需要同时满足非会员和下载数为0的条件')
        shouldProceed = userInfo.is_vip == 0 && rootState.downingNum == 0
      } else if (type == 2) {
        // 下载C页：只需要满足非会员条件
        // console.log('下载C页：只需要满足非会员条件')
        shouldProceed = userInfo.is_vip == 0
      }
      // console.log('是否是会员',userInfo.is_vip)
      // console.log('当前下载数',rootState.downingNum)
      if (shouldProceed) {
        try {
          // 动态导入是因为防止依赖循环 该模块在store/index里面导入了，但是在axios里面又引入了store/index 会导致页面白屏,改用独立的vuex模块 又会导致数据不同步的问题,所以动态导入是最优方案
          const { getDownloadTokenAPI } = await import(
            '@/utils/apiList/downpage'
          )
          const res = await getDownloadTokenAPI()
          if (res.status == 1) {
            commit('SET_SOCKET_NUM', Number(res.data.max_retry_num) || 3)

            if (res.data.switch == 1) {
              dispatch('initDownWebSocket', res.data.token)
            }
          }
        } catch (error) {
          // console.log('error:', error)
        }
      }
    },

    initDownWebSocket({ state, commit, dispatch }, token) {
      if (
        state.wsDown &&
        state.wsDown.readyState != WebSocket.CLOSED &&
        state.wsDown.readyState == WebSocket.OPEN
      ) {
        // console.log('已有未关闭且处于打开状态的WebSocket连接，不再重新连接')
        return
      }

      if (!state.wsDown || state.wsDown.readyState == WebSocket.CLOSED) {
        // console.log('之前的连接不存在或已关闭，创建新的WebSocket连接')
        commit('SET_RETRY_COUNT', 0)
        dispatch('downLoadWebSocket', token)
      }
    },

    downLoadWebSocket({ state, commit, rootState, dispatch }, token) {
      const userInfo = rootState.userInfo
      const url = `${userInfo.push_url}/download?os=pc&download_token=${token}`
      const ws = new WebSocket(url)
      commit('SET_WS_DOWN', ws)

      ws.onopen = () => {
        // console.log('WebSocket连接成功', rootState.downingNum)
        commit('SET_RETRY_COUNT', 0)
        ws.send(state.heartBeatMessage)
        dispatch('startDownHeartBeat')
      }

      ws.onmessage = event => {
        if (event.data == 'hb') return

        try {
          const data = JSON.parse(event.data)
          // console.log('收到消息', data)
          if (data.status == 1 && data.msg_id == '10001') {
            EventBus.$emit(
              'checkVipUrl',
              true,
              data.data.risk_verification_token
            )
            dispatch('closeDownSocket')
          }
        } catch (e) {
          // console.log('error:', e)
        }

        dispatch('resetDownHeartBeat')
      }

      ws.onclose = event => {
        // console.log('WebSocket连接关闭', event)
        dispatch('clearDownHeartBeatTimer')
      }

      ws.onerror = error => {
        // console.log('WebSocket错误:', error)
        dispatch('clearDownHeartBeatTimer')
        dispatch('handleRetry', token)
      }
    },

    handleRetry({ state, commit, dispatch }, token) {
      if (state.downRetryCount < state.downSocketNum) {
        commit('SET_RETRY_COUNT', state.downRetryCount + 1)
        setTimeout(() => {
          dispatch('downLoadWebSocket', token)
        }, 5000)
      } else {
        // console.log(`已达到最大重试次数 停止重试`)
      }
    },

    resetDownHeartBeat({ dispatch }) {
      dispatch('clearDownHeartBeatTimer')
      dispatch('startDownHeartBeat')
    },

    clearDownHeartBeatTimer({ state, commit }) {
      if (state.downHeartBeatTimer) {
        clearInterval(state.downHeartBeatTimer)
        commit('SET_HEARTBEAT_TIMER', null)
      }
    },

    startDownHeartBeat({ state, commit }) {
      if (
        state.wsDown &&
        state.wsDown.readyState == WebSocket.OPEN &&
        !state.downHeartBeatTimer
      ) {
        const timer = setInterval(() => {
          if (state.wsDown && state.wsDown.readyState == WebSocket.OPEN) {
            // console.log('心跳')
            state.wsDown.send(state.heartBeatMessage)
          } else {
            clearInterval(timer)
            commit('SET_HEARTBEAT_TIMER', null)
          }
        }, 10000)

        commit('SET_HEARTBEAT_TIMER', timer)
      }
    },

    closeDownSocket({ state, commit, dispatch }) {
      dispatch('clearDownHeartBeatTimer')
      // 增加对WebSocket实例的类型校验
      if (
        state.wsDown &&
        state.wsDown instanceof WebSocket &&
        typeof state.wsDown.close === 'function'
      ) {
        try {
          state.wsDown.close()
        } catch (error) {}
      }
      commit('SET_WS_DOWN', null)
    },
  },
}
